<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemCharacter',
})
</script>
<template>
  <div>
    <a-card>
      <div class="system-character-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="角色名称">
                <a-input v-model:value="state.tableData.param.name" placeholder="请输入角色名称" :maxlength="20" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <!-- <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
            </a-col> -->
            <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12" class="mb-[10px]">
              <div class="card-col-action flex justify-start min-[1200px]:justify-end">
                <ant-button class="add" @click="openDialog('add', {})" type="primary" v-auth="'character.add'">
                  <PlusOutlined />新增角色
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'permType'">
            {{ record.permType === '1' ? '全区域' : record.permType === '2' ? '所属队站' : `指定区域：${record.permName}` }}
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="openDialogDetail(record)">查看人员</a-button>
              <a-button type="link" size="small" @click="openDialog('edit', record)"
                v-auth="'character.edit'">编辑</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)" v-auth="'character.del'">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
    <CharacterDialog ref="CharacterDialogRef" @create-update="createUpdate" />
    <DetailDialog ref="DetailDialogRef" />
  </div>
</template>

<script setup lang="ts" name="systemCharacter">
import { reactive, ref, onMounted, h } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, PlusOutlined, RedoOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useCharacter } from '@/store/system/character'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
const characterStore = useCharacter()
import CharacterDialog from './dialog.vue'
import DetailDialog from './dialogDetail.vue'

const CharacterDialogRef = ref()
const DetailDialogRef = ref()

const columns = [
  { title: '序号', key: 'index', width: 80, customRender: ({ index }: { index: number }) => index + 1, align: 'center' },
  { title: '角色名称', dataIndex: 'name', key: 'name', ellipsis: true, align: 'center' },
  { title: '数据范围', dataIndex: 'permType', key: 'permType', align: 'center' },
  { title: '用户数量', dataIndex: 'userNum', key: 'userNum', ellipsis: true, align: 'center' },
  { title: '操作', key: 'action', width: 200, align: 'center' }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      name: ''
    }
  }
})

const resetFun = () => {
  state.tableData.param.name = ''
  state.tableData.param.pageNum = 1
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => characterStore.roleList(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const openDialog = (type: string, row: any) => {
  if (type === 'add') {
    CharacterDialogRef.value.openDialog(type, row)
  } else {
    characterStore.getRoleInfo(row.id).then((data: any) => {
      CharacterDialogRef.value.openDialog(type, data)
    })
  }
}

const openDialogDetail = (row: any) => {
  characterStore.getUserByRole(row.id).then((data: any) => {
    DetailDialogRef.value.openDialog(data, row.name)
  })
}

const onDelete = (row: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除角色："${row.name}"，是否继续?`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return characterStore.deleteRoleInfo(row.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const createUpdate = () => {
  message.success('操作成功')
  getTableData()
  CharacterDialogRef.value.closeDialog()
}

onMounted(() => {
  console.log('systemCharacter onMounted')
  getTableData()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
